import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  cookiePresent(name) {
    return document.cookie.indexOf(name + '=') != -1
  }

  setCookie(name, value, expiration_days) {
    const expiration_date = new Date()
    expiration_date.setDate(expiration_date.getDate() + expiration_days)
    const cookie_value = escape(value) + ((expiration_days==null) ? "" : "; expires=" + expiration_date.toUTCString())
    document.cookie = name + "=" + cookie_value + "; path=/"
  }

  // Delete cookie by setting its expiration date to way in the past
  deleteCookie(c_name) {
    document.cookie = c_name + "=1; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/"
  }
}
